import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../auth/fetchWithAuth';
import DashboardFeatureCard from './cards/DashboardFeatureCard';
import TaskTicketList from './tasks/TaskTicketList';
import { assetTaskUrl } from '../utils/openViewParams';
import { API_URL } from '../../config/env';

const LIST_QUERY = 'created_by_me=1&status=all&kind=all&limit=10';

export default function TasksYouCreatedCard({ colSize = 'col-lg-6 col-md-12 mb-3' }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchWithAuth(
          `${API_URL}/v1/admin/tasks?${LIST_QUERY}`,
          { cache: 'no-store' }
        );
        if (!res.ok) throw new Error('Failed to load tasks');
        const json = await res.json();
        if (!cancelled) setItems(Array.isArray(json) ? json : []);
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleItemClick = (task) => {
    if (!task.asset?.id) return;
    navigate(
      assetTaskUrl(task.asset.id, task.id, {
        tab: task.workflow?.user_workflow ? 'feedback' : 'history',
      })
    );
  };

  return (
    <DashboardFeatureCard
      className={colSize}
      title="Tasks you created"
      titleAside={
        <Link to={`/admin/tasks?${LIST_QUERY}`} className="small text-decoration-none">
          View all
        </Link>
      }
      footer="Up to 10 most recently updated tasks you assigned (open or closed)."
    >
      <TaskTicketList
        items={items}
        loading={loading}
        error={error}
        emptyMessage="No tasks yet."
        hideFilter
        onItemClick={handleItemClick}
      />
    </DashboardFeatureCard>
  );
}

TasksYouCreatedCard.propTypes = {
  colSize: PropTypes.string,
};
